import React from "react";

// import {introductionPageAssetConfig} from "../../../../data/introduction/index"


interface IframeworkHtmlElement {
    data: {}
}

export const frameworkHtmlElement: IframeworkHtmlElement = {
    data: {
        "COMPONENTS": []
    }

};
export const htmlElementConfigurationContext = React.createContext(
    {}
);